<template>
  <div id="NotFound" @click.stop="toHomePage()" />
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    toHomePage() {
      window.location.href = '/'
    }
  }
}
</script>

<style lang="scss" scoped>
#NotFound{
  height:500px;
  background: url(~@/assets/images/notfound.png) no-repeat center center;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/not_found.vue